import { render, staticRenderFns } from "./JsonRichText.vue?vue&type=template&id=cd2b5aac"
import script from "./JsonRichText.vue?vue&type=script&lang=js"
export * from "./JsonRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports